import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { AdminUserMemberships } from "./membership-types";

/** Root of the per-user memberships reads; the user id is appended. Under `["admin","users"]`, so access writes refresh it. */
export const USER_MEMBERSHIPS_QUERY_KEY = ["admin", "users", "memberships"] as const;

function membershipsPath(userId: string): string {
  return `/api/admin/users/${encodeURIComponent(userId)}/memberships`;
}

/**
 * `GET /api/admin/users/:id/memberships` — every membership of the user
 * (OWNER / ADMIN / STAFF, ACTIVE and INACTIVE) with its organization, the
 * role's permissions and, for STAFF, the assigned locations. Needs
 * `org.members.read` (ADMIN + SUPPORT), so callers pass `enabled` from the
 * viewer's permission instead of letting a FINANCE viewer hit a 403.
 */
export function useUserMemberships(userId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: [...USER_MEMBERSHIPS_QUERY_KEY, userId] as const,
    queryFn: () => {
      if (!userId) throw new Error("useUserMemberships requires a userId");
      return httpClient<AdminUserMemberships>(membershipsPath(userId));
    },
    enabled: Boolean(userId) && enabled,
    staleTime: 15_000,
  });
}
